<template>
	<div class="trun-early-warning">
		<div class="page-handle">
			<div class="left">
				<a-button type="primary" @click="addEarlyWarning">添加预警设置</a-button>
			</div>
			<div class="right">
				<a-dropdown overlayClassName="hospital-dropdown-overlay" class="hospital-dropdown-link">
					<a class="ant-dropdown-link">
						{{searchLableKey}}
						<a-icon type="down"/>
					</a>
					<a-menu slot="overlay" style="height: 300px; overflow: hidden; overflow-y: scroll;"
					        @click="onClickSearchModuleKey">
						<a-menu-item key="-1">
							<a href="javascript:;">全部</a>
						</a-menu-item>
						<a-menu-item v-for="item in moduleItems" :key="item.key">
							<a href="javascript:;">{{item.value}}</a>
						</a-menu-item>
					</a-menu>
				</a-dropdown>
				<a-dropdown overlayClassName="hospital-dropdown-overlay" class="hospital-dropdown-link">
					<a class="ant-dropdown-link">
						{{searchStatusLableKey}}
						<a-icon type="down"/>
					</a>
					<a-menu slot="overlay" style="height: 300px; overflow: hidden; overflow-y: scroll;"
					        @click="onClickSearchStatusKey">
						<a-menu-item key="-1">
							<a href="javascript:;">全部</a>
						</a-menu-item>
						<a-menu-item v-for="item in statusItems" :key="item.key">
							<a href="javascript:;">{{item.value}}</a>
						</a-menu-item>
					</a-menu>
				</a-dropdown>
			</div>
		</div>
		<div class="page-content page-turn-content">
			<a-table
					:pagination="false"
					:columns="columns"
					:dataSource="dataList"
					:rowKey="record => record.id"
					:loading="loading"
					class="hospital-table"
					size="middle"
			>

				<template slot="opt" slot-scope="text,record">
					<a href="javascript:;" @click="editEarlyWarning(record)" class="cf-mr10">编辑</a>
					<a v-if="!record.delFlag" href="javascript:;" @click="updateUserable(record)" class="cf-mr10">删除</a>
				</template>
			</a-table>
		</div>
		<page-model @close="closeModel" :visible="visible">
			<early-warning-add :dataRow="selectData" v-if="visible" @close="closeModel"></early-warning-add>
		</page-model>
		<h-confirm
				:visible="confirmVisible"
				@close="closeConfirm"
				@ok="okClick"
				:loadding.sync="confirmLoadding"
				:title="currentConfirmData.title"
				:content="currentConfirmData.content"
				:desc="currentConfirmData.desc"
		></h-confirm>
	</div>
</template>

<script>
  import EarlyWarningAdd from "./earlyWarningAdd.vue";

  const columns = [
    {
      title: "序号",
      customRender: (text, record, index) => `${index + 1}`
    },
    {
      title: "提醒模块",
      dataIndex: "moduleValue",
      scopedSlots: {customRender: "moduleValue"},
    },
    {
      title: "提醒状态",
      dataIndex: "statusValue",
      scopedSlots: {customRender: "statusValue"},
    },
    {
      title: "提醒时长(小时)",
      dataIndex: "hours",
      scopedSlots: {customRender: "hours"},
    },
    {
      title: "创建时间",
      dataIndex: "createTime"
    },
    {
      title: "状态",
      dataIndex: "delFlag",
      customRender: (text, record, index) => {
        if (!record.delFlag) {
          return '启用';
        } else {
          return '禁用';
        }
      }
    },
    {
      title: "操作",
      scopedSlots: {customRender: "opt"},
      width: '15%'
    }
  ];
  export default {
    data() {
      return {
        columns,
        dataList: [],
        loading: false,
        page: 1,
        pageSize: 10,
        visible: false,
        queryStr: {
          module: '',
          status: ''
        },
        selectData: {},
        confirmLoadding: false,
        confirmVisible: false,
        moduleItems: [],
        statusItems: [],
        searchLableKey: '提醒模块',
        searchStatusLableKey: '状态',
        currentConfirmData: {
          title: "状态修改",
          content: "您确认禁用提醒模块吗？",
          desc: ""
        }
      };
    },
    components: {EarlyWarningAdd},
    mounted() {
      this.getModuleData();
      this.getStatusData();
      this.getDataList();
    },
    methods: {
      getModuleData() {
        this.$get("allconfig/warning/modules").then(res => {
          this.moduleItems = res.data.data;
        });
      },
      getStatusData() {
        this.$get("allconfig/warning/status").then(res => {
          this.statusItems = res.data.data;
        });
      },
      getDataList() {
        this.dataList = [];
        this.loading = true;
        this.$get("allconfig/warning", {
          module: this.queryStr.module,
          status: this.queryStr.status,
        }).then(res => {
          this.dataList = res.data.data;
          this.loading = false;
        });
      },
      addEarlyWarning() {
        this.selectData = null;
        this.visible = true;
      },
      editEarlyWarning(row) {
        this.selectData = row;
        this.visible = true;
      },
      updateUserable(row) {
        this.selectData = row;
        if (row.delFlag === 1) {
          this.currentConfirmData.content = '您确认启用提醒模块吗'
        }
        this.confirmVisible = true;
      },
      onClickSearchModuleKey({key}) {
        if (key == '-1') {
          this.queryStr.module = '';
          this.searchLableKey = '提醒模块';
        } else {
          let textValue = '';
          this.queryStr.module = key;
          this.moduleItems.forEach(function (item, i) {
            if (item.key == key) {
              textValue = item.value;
              return;
            }
          })
          this.searchLableKey = textValue;
        }
        this.getDataList();
      },
      onClickSearchStatusKey({key}) {
        if (key == '-1') {
          this.queryStr.status = '';
          this.searchStatusLableKey = '状态';
        } else {
          let textValue = '';
          this.queryStr.status = key;
          this.statusItems.forEach(function (item, i) {
            if (item.key == key) {
              textValue = item.value;
              return;
            }
          })
          this.searchStatusLableKey = textValue;
        }
        this.getDataList();
      },
      okClick() {
        this.$put("allconfig/warning/" + this.selectData.id, {userable: !!this.selectData.delFlag}).then(
          res => {
            if (res.data && res.data.code) {
              this.confirmVisible = false;
              this.confirmLoadding = false;
              this.$message.success("操作成功");
              this.getDataList();
            } else {
              this.confirmLoadding = false;
              this.$message.error(res.data.message);
            }
          },
          err => {
            this.confirmLoadding = false;
            this.$message.error("操作失败");
          }
        );
      },
      closeConfirm() {
        this.confirmVisible = false;
      },
      closeModel() {
        this.visible = false;
        this.getDataList();
      },
    }
  }
</script>

<style lang="scss" scoped>
	.trun-early-warning {
		.pagination {
			padding: 0 30px;
		}
	}
</style>